var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerBiWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_265_2109)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_265_2109",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1004 0H0.900391V33.9H33.1004V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_265_2109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1004 27.3002C11.1004 28.4002 10.2004 29.4002 9.00039 29.4002C7.80039 29.4002 6.90039 28.5002 6.90039 27.3002V18.3002C6.90039 17.2002 7.80039 16.2002 9.00039 16.2002C10.2004 16.2002 11.1004 17.1002 11.1004 18.3002V27.3002Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_265_2109",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1004 0H0.900391V33.9H33.1004V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_265_2109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1 29.6999C17.1 30.7999 16.2 31.7999 15 31.7999C13.8 31.7999 13 30.8999 13 29.6999V15.9999C13 14.8999 13.9 13.8999 15.1 13.8999C16.3 13.8999 17.2 14.7999 17.2 15.9999V29.6999H17.1Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_265_2109",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1004 0H0.900391V33.9H33.1004V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_265_2109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.00078 25.2998C5.00078 26.3998 4.10078 27.3998 2.90078 27.3998C1.70078 27.3998 0.800781 26.4998 0.800781 25.2998V20.3998C0.800781 19.2998 1.70078 18.2998 2.90078 18.2998C4.10078 18.2998 5.00078 19.2998 5.00078 20.3998V25.2998Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_265_2109",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1004 0H0.900391V33.9H33.1004V0Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_265_2109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1 31.9001C23.1 33.0001 22.2 34.0001 21 34.0001C19.9 34.0001 19 33.0001 19 31.9001V13.7001C19 12.6001 19.9 11.6001 21.1 11.6001C22.2 11.6001 23.2 12.5001 23.2 13.7001V31.9001H23.1Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_265_2109",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1004 0H0.900391V33.9H33.1004V0Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_265_2109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7004 31.0001C29.3004 31.0001 29.0004 30.9001 28.6004 30.8001L26.1004 30.0001C25.7004 29.9001 25.4004 29.4001 25.6004 29.0001C25.7004 28.6001 26.2004 28.3001 26.6004 28.5001L29.2004 29.3001C29.7004 29.5001 30.3004 29.4001 30.8004 29.0001C31.3004 28.7001 31.5004 28.1001 31.5004 27.6001V10.9001C31.5004 10.1001 31.0004 9.40008 30.3004 9.20008L5.80039 1.80008C5.30039 1.60008 4.70039 1.70008 4.20039 2.00008C3.80039 2.40008 3.50039 2.90008 3.50039 3.50008V15.0001C3.50039 15.5001 3.10039 15.8001 2.70039 15.8001C2.20039 15.8001 1.90039 15.4001 1.90039 15.0001V3.50008C1.90039 2.40008 2.40039 1.40008 3.30039 0.800082C4.20039 0.100082 5.30039 8.23289e-05 6.30039 0.300082L30.7004 7.70008C32.1004 8.10008 33.1004 9.50008 33.1004 11.0001V27.7001C33.1004 28.8001 32.6004 29.8001 31.7004 30.5001C31.1004 30.7001 30.4004 31.0001 29.7004 31.0001Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_265_2109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerBiWhiteLogo);
export default __webpack_public_path__ + "static/media/PowerBIWhiteLogo.ae1678981f502dc3bd4884696d99c98d.svg";
export { ForwardRef as ReactComponent };